(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ELEMENT"), require("VueRouter"), require("Vue"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["ELEMENT", "VueRouter", "Vue", "axios"], factory);
	else if(typeof exports === 'object')
		exports["@smallwei/avue-data-app"] = factory(require("ELEMENT"), require("VueRouter"), require("Vue"), require("axios"));
	else
		root["@smallwei/avue-data-app"] = factory(root["ELEMENT"], root["VueRouter"], root["Vue"], root["axios"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__5f72__, __WEBPACK_EXTERNAL_MODULE__6389__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 